// extracted by mini-css-extract-plugin
export default {"main__section":"Dashboard_main__section__+yYBn","h3":"Dashboard_h3__1ovAk"};